"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFilteredPromotions = void 0;
var swr_hooks_1 = require("@l2p/swr-hooks");
var WELCOME_DEPOSITS = [
    swr_hooks_1.BonusTag.WELCOME_DEPOSIT_FIRST,
    swr_hooks_1.BonusTag.WELCOME_DEPOSIT_SECOND,
    swr_hooks_1.BonusTag.WELCOME_DEPOSIT_THIRD,
    swr_hooks_1.BonusTag.WELCOME_DEPOSIT_FOURTH,
];
var useFilteredPromotions = function () {
    var _a = (0, swr_hooks_1.usePromotionsByTag)(swr_hooks_1.BonusTag.POSITION_HOME_BANNER), promotions = _a.promotions, isLoading = _a.isLoading;
    var filteredPromotions = promotions.filter(function (promo) {
        if (WELCOME_DEPOSITS.includes(promo === null || promo === void 0 ? void 0 : promo.slug) && !promo.canActivate)
            return false;
        return true;
    });
    return { promotions: filteredPromotions, isLoading: isLoading };
};
exports.useFilteredPromotions = useFilteredPromotions;
